<template>
  <div class="tabs-container">
    <div class="tabs">
      <div class="tab-list">
        <div class="tab-item" :class="{ 'is-active': item.name === tabActive }" v-for="item in tabList" :key="item.name" :name="item.name" @click="tabClick(item)">{{ item.title }}</div>
      </div>
      <div class="tabs-operation">
        <slot name="ope" />
      </div>
    </div>
    <div class="tabs-content">
      <slot />
    </div>
  </div>
</template>

<script>
  import { validatenull } from "@/util/validate";
  
  export default {
    name: "bspTabs",
    props:{
      tabList:{
        type: Array,
        default: () =>{
          []
        }
      },
      tabIndex:{
        type:String,
        default:''
      }
    },
    beforeDestroy(){
      sessionStorage.removeItem("tabIndex")
    },
    watch:{
      'tabIndex':{
        handler(val){
          this.tabActive = val
        },
        immediate:true
      }
    },
    data(){
      return {
        tabActive: null
      }
    },
    methods:{
      tabClick(tab){
        if (tab.name != this.tabActive) {
          this.tabActive = tab.name
          this.$emit('changeTab', tab)
          this.$emit('update:tabIndex', tab.name)
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .tabs-container {
    /*padding: 20px;*/
    .tabs {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .tab-list {
        background-color: #F6F6F6;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
        border-radius: 20px;
      }
     
      .tab-item {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        display: inline-block;
        position: relative;
        cursor: pointer;
        &+.tab-item {
          &:before {
            content: '';
            display: inline-block;
            width: 2px;
            height: 14px;
            background-color: #e8eaec;
            position: absolute;
            left: 2px;
            top: 50%;
            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%);
          }
        }
        &.is-active {
          color: #F73A0B;
          font-weight: bold;
        }
      }
    }
    .bsp-grid{
      height: calc(100vh - 205px);
    }
  }
</style>
